import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'TableEmptyState',
  props: {
  title: {
    type: String,
    default: "Nenhum item encontrado",
  },
  icon: {
    type: String,
    default: "fa-solid fa-folder-open",
  },
  height: {
    required: false,
    default: "vh-50",
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_Typograph = _resolveComponent("Typograph")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["align-items-center d-flex flex-column flex-fill justify-content-center", __props.height])
  }, [
    _createElementVNode("i", {
      class: _normalizeClass([__props.icon, "text-muted fa-2x mb-2"])
    }, null, 2),
    _createVNode(_component_Typograph, {
      variant: "header",
      class: "text-muted"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.title), 1)
      ]),
      _: 1
    })
  ], 2))
}
}

})